// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleteModel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 40px 0;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 99999;
  opacity: 0;
  visibility: hidden;
  background-color: rgba(0, 0, 0, 0.425);
}
.deleteModel .deleteItem {
  position: relative;
  width: 450px;
  height: 350px;
  background-color: #fff;
  z-index: 666666;
  border-radius: 10px;
  flex-direction: column;
}
.deleteModel .deleteItem .close {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
.deleteModel .deleteItem .icon {
  margin-bottom: 25px;
}
.deleteModel .deleteItem h4 {
  color: #495057;
}
.deleteModel .deleteItem div button {
  margin: 0 5px;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
}
.deleteModel .deleteItem div .insure {
  background-color: #ee4726;
  color: #fff;
}
.deleteModel .show-enter {
  opacity: 0;
  transform: scale(0.8);
  transition: 300ms;
}
.deleteModel .show-enter-active {
  opacity: 1;
  transform: scale(1);
  transition: 300ms;
}
.deleteModel .show-exit {
  transition: 0ms;
  opacity: 1;
}
.deleteModel .show-exit-active {
  transition: 400ms;
  opacity: 0;
}
@media (max-width: 768px) {
  .deleteModel .deleteItem {
    width: 400px;
    height: 300px;
  }
}
@media (max-width: 500px) {
  .deleteModel .deleteItem {
    width: 90%;
    height: 300px;
  }
  .deleteModel .deleteItem p {
    font-size: 13px;
    text-align: center;
  }
}

.model-show {
  opacity: 1;
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/components/Ui/DeleteItem/deleteItem.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,sCAAA;AACF;AAAE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAEJ;AADI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,cAAA;AAGN;AAAM;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAER;AAAM;EACE,yBAAA;EACA,WAAA;AAER;AAEE;EACE,UAAA;EACA,qBAAA;EACA,iBAAA;AAAJ;AAEE;EACE,UAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;AAEE;EACE,eAAA;EACA,UAAA;AAAJ;AAEE;EACE,iBAAA;EACA,UAAA;AAAJ;AAEE;EACE;IACE,YAAA;IACA,aAAA;EAAJ;AACF;AAEE;EACE;IACE,UAAA;IACA,aAAA;EAAJ;EACI;IACE,eAAA;IACA,kBAAA;EACN;AACF;;AAGA;EACE,UAAA;EACA,mBAAA;AAAF","sourcesContent":[".deleteModel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 40px 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 99999;\n  opacity: 0;\n  visibility: hidden;\n  background-color: rgba(0, 0, 0, 0.425);\n  .deleteItem {\n    position: relative;\n    width: 450px;\n    height: 350px;\n    background-color: #fff;\n    z-index: 666666;\n    border-radius: 10px;\n    flex-direction: column;\n    .close {\n      position: absolute;\n      top: 20px;\n      right: 20px;\n      cursor: pointer;\n    }\n    .icon {\n      margin-bottom: 25px;\n    }\n    h4 {\n      color: #495057;\n    }\n    div {\n      button {\n        margin: 0 5px;\n        padding: 10px 15px;\n        border-radius: 5px;\n        font-size: 14px;\n      }\n      .insure {\n        background-color: #ee4726;\n        color: #fff;\n      }\n    }\n  }\n  .show-enter {\n    opacity: 0;\n    transform: scale(0.8);\n    transition: 300ms;\n  }\n  .show-enter-active {\n    opacity: 1;\n    transform: scale(1);\n    transition: 300ms;\n  }\n  .show-exit {\n    transition: 0ms;\n    opacity: 1;\n  }\n  .show-exit-active {\n    transition: 400ms;\n    opacity: 0;\n  }\n  @media (max-width: 768px) {\n    .deleteItem {\n      width: 400px;\n      height: 300px;\n    }\n  }\n  @media (max-width: 500px) {\n    .deleteItem {\n      width: 90%;\n      height: 300px;\n      p {\n        font-size: 13px;\n        text-align: center;\n      }\n    }\n  }\n}\n.model-show {\n  opacity: 1;\n  visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
